import { IconAgentIcon } from '@coze-arch/bot-icons';
import { IconCozCrossCircle, IconCozScene,IconCozDiamond } from '@coze-arch/coze-design/icons';

//超级管理员账号
export const SUPER_ADMINS = ["15555555555"];

//图片精度配置值
export const globalImageSizeItems =[
    {
      key: 'low',
      label: '低精度',
      value: 0,
      desc: 'fov较大，分辨率为1440×1080，建议用于场景分析、远景采集等智能体。',
    },
    {
      key: 'high',
      label: '高精度',
      value: 4,
      desc: 'fov较小，分辨率为2016*1512，建议用于学习指导、拍照购物等智能体。',
    },
];
  
//智能体启动设置
export const globalInputParmsItems = [
  {
    key: 'text',
    label: '文字',
    value: 'question',
    desc:'来自眼睛端的语音输入。'
  },
  {
    key: 'image',
    label: '图片(首轮传递)',
    value: 'image_first',
    desc:'仅启动时由智能体调用相机拍照。'
  },
];

//智能体类型
export const agentKindList = [
  { key: 'rizon', label: '灵珠智能体', icon: IconAgentIcon, childTypes: [{type:'lingzhu',name:'灵珠智能体'}] },
  { key: 'third', label: '三方智能体', icon: IconCozScene ,childTypes: [{type:'bailian',name:'百炼智能体'},{type:'custom',name:'自定义智能体'},{type:'coze',name:'扣子智能体'}] },
  // rokid 智能体不再区分 native 和 cut，统一为native，为了兼容旧版cut智能体，保留cut type
  //{ key: 'local', label: 'AIUI智能体', icon: IconCozDiamond,childTypes: [{type:'native',name:'AIUI智能体'},{type:'cut',name:'AIUI智能体'}]  },
];


//模型模式
export const modelModeList = [
  { switch: 'disabled', type: 'disabled', label: '关闭思考', desc: '模型不进行任何思考，直接回复。' },
  { switch: 'enabled', type: 'low', label: '打开思考', desc:'模型进行思考后自行决策与回复。' }
  //目前先提供开关，后续可以增加思考强度的选择
  // { switch: 'enabled', type: 'low', label: '轻度', desc:'模型进行轻度思考。' },
  // { switch: 'enabled', type: 'medium', label: '中度', desc:'模型进行中度思考。' },
  // { switch: 'enabled', type:'high',label: '深度', desc:'模型进行深度思考。' },
];